import { type FC, useMemo } from "react";

interface SvgRendererProps {
  content: string;
}

/**
 * Renders SVG artifacts via an <img> tag with a base64 data URI.
 * This prevents any embedded scripts from executing.
 */
export const SvgRenderer: FC<SvgRendererProps> = ({ content }) => {
  const dataUri = useMemo(() => {
    if (!content) return "";
    try {
      const encoded = btoa(unescape(encodeURIComponent(content)));
      return `data:image/svg+xml;base64,${encoded}`;
    } catch {
      return "";
    }
  }, [content]);

  if (!content || !dataUri) {
    return (
      <div className="cuadra-p-4 cuadra-text-sm cuadra-text-[var(--cuadra-text-secondary)]">
        No content
      </div>
    );
  }

  return (
    <div className="cuadra-flex cuadra-items-center cuadra-justify-center cuadra-h-full cuadra-p-4 cuadra-overflow-auto cuadra-bg-[var(--cuadra-bg-primary)]">
      <img
        src={dataUri}
        alt="SVG artifact"
        className="cuadra-max-w-full cuadra-max-h-full cuadra-object-contain"
      />
    </div>
  );
};
